import React, { useMemo, useContext } from 'react';
import { Tooltip, Box } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { fCurrency } from '../../../../../utils/formatNumber';
import { ShopCartContext, ShopDataContext } from '../_ShopViewContext';

export default function CartTotalBox() {
  const { cart: cartData } = useContext(ShopCartContext);
  const { data } = useContext(ShopDataContext);

  const cartTotal = useMemo(() => {
    const cartItems = data.filter(x => x.productDetails?.length && (x.quantity > 0 || cartData[x.id] > 0)).map(x => ({
      quantity: cartData[x.id] !== undefined ? cartData[x.id] : x.quantity,
      price: x.productDetails[0].price,
    }));
    return cartItems?.reduce((sum, item) => sum + (item.quantity || 0) * (item.price || 0), 0);
  }, [cartData, data]);

  return (
    <Tooltip title="Cart Total" placement="top" arrow>
      <Box
        sx={{
          ml: 1,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          px: 1.5,
          py: 0.5,
          borderRadius: '12px',
          backgroundColor: '#f5f5f5',
          fontSize: '0.85rem',
          fontWeight: 500,
          color: '#444',
        }}
      >
        <ShoppingCartIcon sx={{ fontSize: 18, color: 'primary.main' }} />
        {fCurrency(cartTotal)}
      </Box>
    </Tooltip>
  );
}

